import { DataCenterModel } from './dataCenterModal';

export class IManageConnectionModel {
  connectionGuid: string;
  connectionName: string;
  iManageServerURL: string;
  connectionAccessType: string;
  iManageLibraries: LibraryList[];
  dataCenterGuid: string;
  dataCenterName: string;
  iManageUserId: string;
  iManagePassword: string;
  libraries: string[];
  librarieNames: string[];
  isEnabled: boolean;
  accessPeriodStart: string;
  accessPeriodEnd: string;
  lastSynchronizationDate: string;
  isConnectionStateActive: boolean;
  dataCenterInfo: DataCenterModel[];
  taskType: string;
  synchronizationStatus: string;
  isPasswordUpdated: boolean
  isSPMIntegration: boolean;
  spmServerUrl: string;
  spmUserName: string;
  spmPassword: string;
  spmEnabled: boolean;
  isSpmPasswordUpdated: boolean;
  spmIgnoreCertificateErrors: boolean;
  spmStatusMessage: string;
  spmIsConnected: boolean;
  isSyncing: boolean;
  isConnected: boolean;
  statusMessage: string;
  isSpmError: boolean;
  hasValidCredentials: boolean
  constructor() {
    this.connectionGuid = '';
    this.connectionName = '';
    this.dataCenterGuid = '';
    this.iManageServerURL = '';
    this.iManageUserId = '';
    this.iManagePassword = '';
    this.libraries = [];
    this.isEnabled = false;
    this.dataCenterInfo = [];
    this.synchronizationStatus = 'NeverRun';
    this.isSPMIntegration = false;
    this.spmServerUrl = '';
    this.spmUserName = '';
    this.spmPassword = '';
    this.spmEnabled = false;
    this.isSpmPasswordUpdated = false;
    this.spmIgnoreCertificateErrors = false;
    this.spmStatusMessage = '';
    this.spmIsConnected = false;
    this.isSpmError = false;
  }
}

export class LibraryList {
  name: string;
  number: number;
  libraryGuid: string;
  isSelected: boolean;
  storageType: number;
  hasAccesskey : boolean
}
export class IManageTestConnectionModel {
  iManageUserId: string;
  iManagePassword: string;
  iManageServerURL: string;
  connectionGuid: string;
  isNewConnection: boolean;
  isPasswordUpdated: boolean;
  isSPMIntegration: boolean;
  spmServerUrl: string;
  spmUserName: string;
  spmPassword: string;
  spmIgnoreCertificateErrors: boolean;
}

export class ConnectionStateModel {
  connectionGuid: string;
  imanageLibraries: LibraryList[];
  userAccessCodeId: number;
  userAccessCode: string;
  isConnectionStateActive: boolean;
  connectionAccessType: string;
  dataCenterBaseUrl: string;
}

export class ConnectionStateChangeModel {
  connectionGuid: string;
  isEnabled: boolean;
  dataCenterGuid: string;
}

export class IManageLibraryRequest {
  libraryGuid: string;
  connectionString: string;
}
